import { Typography } from 'design-component';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { palette } from 'styles/color';

interface PageTypography {
  title: string;
  description?: string;
  style?: React.CSSProperties;
}

export default function PageIntro(props: PropsWithChildren<PageTypography>) {
  const { title, description, children, style } = props;
  return (
    <PageTypographyBase style={style}>
      <Typography size="22px" weight={'bold'}>
        {title}
      </Typography>
      {!children ? (
        <Typography size="16px" weight={'normal'} color={palette.gray[500]}>
          {description}
        </Typography>
      ) : (
        children
      )}
    </PageTypographyBase>
  );
}

const PageTypographyBase = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
